import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row } from "antd";

import moment from "moment";

import { userService } from "./../../redux/services";

import {
	UIAvatarLabel,
	UIDrawerForm,
	UIFormSection,
} from "./../../components";

class Show extends Component {
	static propTypes = {
		visible : PropTypes.bool.isRequired,
		onClose : PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid     : 0,
			item     : {},
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid     : uuid,
			item     : {},
		});

		userService.show({uuid})
		.then((response) => {
			this.setState({
				isLoading: false,
				item     : response.data.data,
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	renderRoles = () => {
		const {item} = this.state;

		if( !item.roles || !item.roles.length )
		{
			return <p className="byp-role-option-empty">Nenhum papel atribuído.</p>
		}

		return item.roles.map((role, index) => (
			<div key={index} className="byp-role-option byp-role-option-static">
				<span className="byp-role-option-icon"><i className="fas fa-crown" /></span>
				<span className="byp-role-option-text">
					<span className="byp-role-option-name">{role.name}</span>
					{role.description && <span className="byp-role-option-description">{role.description}</span>}
				</span>
			</div>
		));
	};

	render() {
		const {visible}         = this.props;
		const {isLoading, item} = this.state;

		const isGestor = item.roles?.some(role => role.is_gestor);

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-users" />}
				title="Visualizar usuário"
				subtitle="Confira os dados e as permissões do usuário.">
				<Form layout="vertical">
					<UIFormSection
						icon={<i className="fal fa-user" />}
						title="Informações gerais">
						<Row gutter={16}>
							<Col xs={24}>
								<Form.Item label="Usuário">
									<UIAvatarLabel id={item.id} name={item.name} avatar={item.avatar} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="E-mail">
									{item.email ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Status">
									<span className={`status-tag ${item.is_active ? "status-tag-success" : "status-tag-error"}`}>
										<i className="status-tag-dot" />
										{item.is_active ? "Ativo" : "Inativo"}
									</span>
								</Form.Item>
							</Col>
						</Row>
						{isGestor && (
							<Row gutter={16}>
								<Col xs={24}>
									<Form.Item label="Fluxos de Aprovação">
										{item.equipes?.length ? item.equipes.map(equipe => equipe.nome).join(", ") : "Todos"}
									</Form.Item>
								</Col>
							</Row>
						)}
						<Row gutter={16}>
							<Col xs={24} sm={12}>
								<Form.Item label="Criação">
									{item.created_at ? moment(item.created_at).calendar() : "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={12}>
								<Form.Item label="Última atualização">
									{item.updated_at ? moment(item.updated_at).calendar() : "-"}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
					<UIFormSection
						icon={<i className="fal fa-crown" />}
						title="Papéis e Permissões"
						description="Papéis atribuídos ao usuário e as permissões correspondentes.">
						<div className="byp-role-options">
							{this.renderRoles()}
						</div>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
